import { AutoComplete } from '@wix/design-system'

import { reportError } from '../../../monitoring/reportError'

export class AutoCompleteWithOverrides extends AutoComplete {
  onClickOutside = () => {
    // do nothing
  }

  _onInputClicked = () => {
    try {
      const { showOptions } = this.state as any
      if (!showOptions) {
        // @ts-expect-error
        super._onInputClicked()
      }
    } catch (error) {
      reportError(error as Error)
    }
  }
}
